import { dateFns as moment } from '@pcln/date-fns-utils'

import { logEvent } from '@mfs/client/common/log-ga-event/logGaEvent'
import { buildShopSearchXsellUrl } from '../../../details-client/CrossSellModalAd/crossSellHelpers'
import { calculateLengthOfStay } from '../../../details-client/util/length-of-stay'
import { getNumSlices } from '../../util/sbs'

const FOUR_AM = 4

// Returns the effective hotel check-in date. Listings slices carry no
// willArriveOnDiffDate flag, so derive it from the arrival timestamp: landing at or
// before 4 AM counts as the previous night, and check-in never precedes the search date.
export const getEffectiveCheckInDate = (travelDate, arrivalDateTime) => {
  if (!arrivalDateTime) return travelDate
  const arrivalTime = new Date(arrivalDateTime)
  if (Number.isNaN(arrivalTime.getTime())) return travelDate
  const fourAM = new Date(arrivalTime)
  fourAM.setHours(FOUR_AM, 0, 0, 0)
  const checkInDate =
    arrivalTime.getTime() > fourAM.getTime()
      ? moment(arrivalTime).format('YYYY-MM-DD')
      : moment(arrivalTime).subtract(1, 'days').format('YYYY-MM-DD')
  return checkInDate > travelDate ? checkInDate : travelDate
}

const ahCrossSellGa4Attributes = {
  type: 'add_on',
  bundle_flag: 'y',
  bundle_type: 'AH',
  page_name: 'listings',
  product_name: 'air',
  promotion_name: 'hotel',
  promotion_id: 'ah_crosssell_dialog_return_flight_listing',
  creative_name: 'return_flight_ah_bundle_popup_modal',
}

export const logAHCrossSellEvent = (eventName, extraAttributes = {}) => {
  logEvent(eventName, { ...ahCrossSellGa4Attributes, ...extraAttributes })
}

const ahCrossSellInternalElementAttributes = {
  type: 'return_flight_ah_bundle_popup_modal',
  link_name: 'continue_with_flight_only',
  page_name: 'listings',
  product_name: 'air',
}

export const logAHCrossSellInternalElementEvent = (linkItem) => {
  logEvent('internal_element', { ...ahCrossSellInternalElementAttributes, link_item: linkItem })
}

export const buildAHCrossSellUrl = ({
  pclnBootstrapData,
  outboundItinerary,
  returnItinerary,
  flySessionKey,
}) => {
  const outboundSlice = outboundItinerary?.slices?.[0]
  const returnSlice = returnItinerary?.slices?.[0]

  const flySlices = [outboundSlice, returnSlice]
    .filter(Boolean)
    .map((slice, index) => {
      const sliceId = index === 1 && slice?.id === 1 ? 2 : slice?.id
      return `${sliceId},${slice?.sliceKey}`
    })
    .join(';')

  const proposalComponents = returnItinerary?.proposalComponents ?? []
  const flyComponent = proposalComponents.find((item) => item.type === 'FLY')
  const stayComponent = proposalComponents.find((item) => item.type === 'STAY')

  return buildShopSearchXsellUrl({
    pclnBootstrapData,
    xsellObject: {
      packageTypeCode: 'AH',
      numRooms: 1,
      departureAirport: outboundSlice?.departInfo?.airport?.code,
      returnAirport: outboundSlice?.arrivalInfo?.airport?.code,
      flyKey: flyComponent?.componentKey,
      flyItemKey: flyComponent?.itemKey,
      flyPriceKey: flyComponent?.priceKey,
      flySessionKey,
      stayKey: stayComponent?.componentKey,
      flySlices,
    },
  })
}

export const buildAHCrossSellEligibilityArgs = ({
  id,
  itinerary,
  pclnBootstrapData,
  activeTabId,
  selectedDepartureSummaries,
  tripType,
  travelDate,
  returnDate,
  maxShowCount,
}) => {
  const numSlices = getNumSlices(pclnBootstrapData)
  const departureItinerary = selectedDepartureSummaries?.[0]
  const arrivalDateTime = departureItinerary?.slices?.[0]?.arrivalInfo?.time?.dateTime
  const departureAirlineCode =
    departureItinerary?.airlines?.[0]?.code || departureItinerary?.marketingAirlines?.[0]?.code

  return {
    itinerary,
    selectedPriceKey: id,
    setiDetails: pclnBootstrapData?.seti,
    activeTabId,
    numSlices,
    tripType,
    departureAirlineCode,
    lengthOfStay: calculateLengthOfStay(getEffectiveCheckInDate(travelDate, arrivalDateTime), returnDate),
    maxShowCount,
  }
}
